import React from 'react';
import { iconList } from '@invent/wl-ui-kit';
import {
  PageErrorWrapper,
  PageErrorContent,
  ErrorIcon,
  MainTitleError,
  ExplainBody,
  ActionsField
} from './styled';

type BlankPageErrorPropsT = {
  mainTitle: string;
  explanation: string;
  actions?: JSX.Element[];
  iconName?: keyof typeof iconList;
};

export const BlankPageError = ({
  iconName = 'warning_amber',
  mainTitle,
  explanation,
  actions
}: BlankPageErrorPropsT) => {
  return (
    <PageErrorWrapper>
      <PageErrorContent>
        <ErrorIcon name={iconName} />
        <MainTitleError>{mainTitle}</MainTitleError>
        <ExplainBody>{explanation}</ExplainBody>
        {actions?.length ? <ActionsField>{actions}</ActionsField> : null}
      </PageErrorContent>
    </PageErrorWrapper>
  );
};
